/* ============================================================================
   EASTEAM - HOME LIFESTYLE RAIL - full library + media mix
   ----------------------------------------------------------------------------
   Two things the rail does not do on its own:

   1. IT STOPS AT "Looks in the rail" (max 60 in the section schema, 24 by
      default) out of 204 shoppable looks. It loops, so it never ends, but it
      starts repeating early and reads as thin. This appends every remaining
      look from the same feed the rail already fetched, so the loop runs the
      whole library before it comes back around.

   2. IT DOES NOT ORDER BY MEDIA TYPE, so videos land wherever they fall.

   The rules here, per Scarlett:
     - the first card is always a video
     - video is the priority - every video is used before stills fill in
     - one or two stills between videos, chosen per slot so it reads as a mix
       rather than a metronome
     - when the videos run out, the rest is stills
     - two looks of the same product never sit side by side

   Library as of 16 Sep 2026: 204 shoppable looks, 78 video, 126 stills.

   WHY THIS IS A SEPARATE FILE. sections/ea-home-looks.liquid is 32KB and is
   being edited by more than one person; re-uploading it wholesale to raise a
   cap risks overwriting someone else's work. This attaches from outside, reads
   the feed the rail has already cached, and can be deleted with no trace. The
   card markup below mirrors the rail's own builder - if that section's markup
   ever changes, this needs the same change.

   window.EA_RAIL_MIX = { minStills: 1, maxStills: 2, videoFirst: true,
                          fillLibrary: true, enabled: true }
   ========================================================================== */
(function () {
  "use strict";
  if (window.__EA_RAIL_MIX__) return;
  window.__EA_RAIL_MIX__ = 1;

  var CFG = Object.assign({
    minStills: 1, maxStills: 2, videoFirst: true, fillLibrary: true, enabled: true
  }, window.EA_RAIL_MIX || {});
  if (!CFG.enabled) return;
  if (CFG.maxStills < CFG.minStills) CFG.maxStills = CFG.minStills;

  var CACHE_KEY = 'sa_style_feed_v1';
  var tries = 0;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function handleOf(item) {
    var a = item.querySelector('a.cf-card');
    var h = a && a.getAttribute('href');
    return h ? h.replace(/^.*\/products\//, '') : '';
  }

  function money(cents, cur, fmt) {
    var c = parseInt(cents, 10) || 0;
    try {
      if (window.Shopify && window.Shopify.formatMoney) return Shopify.formatMoney(c, fmt);
    } catch (e) {}
    var n = c / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cur || 'USD',
        minimumFractionDigits: (n % 1 === 0 ? 0 : 2)
      }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }

  /* the rail's own card markup, so appended cards behave identically */
  function buildCard(lk, prod, cur, fmt) {
    var title = (lk.c && lk.c.trim()) || (prod && prod.t) || String(lk.p).replace(/-/g, ' ');
    var price = '';
    if (prod && prod.pr != null) {
      price = money(prod.pr, cur, fmt);
      if (prod.px != null && prod.px !== prod.pr) price = 'From ' + price;
    }
    var media = (lk.t === 'v')
      /* 2026-10-18 (speed): data-ea-poster, not poster - the rail's layout() sets the real
         poster only near the centre card (see sections/ea-home-looks.liquid) */
      ? '<video src="' + esc(lk.u) + '"' + (lk.o ? ' data-ea-poster="' + esc(lk.o) + '"' : '') +
        ' muted loop playsinline preload="none"></video>'
      : '<img src="' + esc(lk.u) + '" alt="' + esc(title) + '" loading="lazy" draggable="false">';
    var d = document.createElement('div');
    d.className = 'cf-item';
    d.setAttribute('data-sa-look', lk.i);
    d.innerHTML =
      '<a class="cf-card" href="/products/' + esc(lk.p) + '" aria-label="' + esc(title) + '">' +
        media +
      '</a>' +
      '<div class="cf-meta">' +
        '<span class="cf-name">' + esc(title) + '</span>' +
        '<span class="cf-price">' + esc(price) + '</span>' +
      '</div>';
    return d;
  }

  /* everything in the library the rail left out, in the feed's own order */
  function extras(track) {
    if (!CFG.fillLibrary) return [];
    var feed;
    try { feed = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) { return []; }
    if (!feed || !feed.looks) return [];

    var root = document.querySelector('.ea-hlr');
    var cur = (root && root.dataset.currency) || 'USD';
    var fmt = (root && root.dataset.moneyFormat) || '${{amount}}';

    var seen = {};
    Array.prototype.forEach.call(track.children, function (el) {
      seen[el.getAttribute('data-sa-look')] = 1;
    });

    var out = [];
    feed.looks.forEach(function (lk) {
      if (!lk || !lk.p || !lk.u) return;          /* brand-only looks are skipped */
      if (seen[lk.i]) return;
      out.push(buildCard(lk, (feed.products || {})[lk.p], cur, fmt));
    });
    return out;
  }

  /* first entry that is not the same product as the card just placed */
  function take(pool, prevHandle) {
    for (var i = 0; i < pool.length && i < 8; i++) {
      if (handleOf(pool[i]) !== prevHandle) return pool.splice(i, 1)[0];
    }
    return pool.shift();
  }

  function mix() {
    var rail = window.eaHomeRail;
    var track = document.querySelector('.ea-hlr .cf-track');

    if (!rail || !track || !track.children.length) {
      if (tries++ < 150) setTimeout(mix, 100);   /* the rail loads lazily */
      return;
    }
    if (track.dataset.eaMixed) return;
    track.dataset.eaMixed = '1';

    /* merchandised cards first, then the rest of the library behind them */
    var items = Array.prototype.slice.call(track.children).concat(extras(track));

    var vids = [], stills = [];
    items.forEach(function (el) {
      (el.querySelector('video') ? vids : stills).push(el);
    });

    if (!vids.length || !stills.length) {
      /* one media type only - still append the extras, but do not interleave */
      if (items.length > track.children.length) {
        var plain = document.createDocumentFragment();
        items.forEach(function (el) { plain.appendChild(el); });
        track.appendChild(plain);
        try { rail.go(0); } catch (e) {}
      }
      return;
    }

    var out = [], prev = '';
    /* gap starts at maxStills so the very first pick is a video */
    var gap = CFG.videoFirst ? CFG.maxStills : 0;

    while (vids.length || stills.length) {
      var wantVideo;
      if (!vids.length) wantVideo = false;
      else if (!stills.length) wantVideo = true;
      else if (gap < CFG.minStills) wantVideo = false;
      else if (gap >= CFG.maxStills) wantVideo = true;
      else wantVideo = Math.random() < 0.5;       /* the wobble */

      var el = take(wantVideo ? vids : stills, prev);
      out.push(el);
      prev = handleOf(el);
      gap = wantVideo ? 0 : gap + 1;
    }

    var frag = document.createDocumentFragment();
    out.forEach(function (el) { frag.appendChild(el); });
    track.appendChild(frag);

    try { if (typeof rail.go === 'function') rail.go(0); } catch (e) {}
  }

  mix();
})();

/* ============================================================================
   COVER VIDEO - play it as soon as the rail is on screen (17 Sep 2026)
   ----------------------------------------------------------------------------
   The rail's own code calls play() on the centre card the moment it builds the
   track. Three things stop that working for the FIRST card:

     - the section starts building 900px BEFORE the rail is on screen, so the
       play() happens while it is still off screen;
     - the cards carry preload="none", so at that moment the video has no data
       at all and the play() promise rejects with NotSupportedError / AbortError;
     - that rejection is swallowed by an empty .catch and never retried, and
       moving the cards into the mixed order above resets any video that had
       started. So the cover sits on its poster frame and never moves.

   This watches the rail, and whenever the centre card is a video it asks for
   the data and plays it - retrying on canplay, on loadeddata, when the tab
   comes back, and whenever the centre card changes. It only ever touches the
   centre card, so the section's own "pause everything else" logic is untouched.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__EA_RAIL_PLAY__) return;
  window.__EA_RAIL_PLAY__ = 1;

  var root, track, visible = false, waits = 0;

  function centreVideo() {
    if (!track) return null;
    var a = track.querySelector('.cf-item.active video');
    if (a) return a;
    var first = track.querySelector('.cf-item video');
    return first || null;
  }

  function kick() {
    if (!visible) return;
    var v = centreVideo();
    if (!v) return;

    v.muted = true;                 /* required for autoplay everywhere */
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');

    if (v.preload !== 'auto') {
      v.preload = 'auto';
      try { v.load(); } catch (e) {}
    }
    if (!v.paused && v.readyState > 2) return;   /* already running */

    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && p.catch) {
      p.catch(function () {
        /* no data yet - come back the moment there is some */
        ['canplay', 'loadeddata'].forEach(function (evt) {
          v.addEventListener(evt, function h() {
            v.removeEventListener(evt, h);
            if (visible) { try { v.play(); } catch (e) {} }
          });
        });
      });
    }
  }

  function attach() {
    root = document.querySelector('.ea-hlr');
    track = root && root.querySelector('.cf-track');
    if (!track) {
      if (waits++ < 200) setTimeout(attach, 100);   /* the rail builds lazily */
      return;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = !!(en[0] && en[0].isIntersecting);
        if (visible) kick();
      }, { threshold: 0.01 }).observe(root);
    } else {
      visible = true;
      kick();
    }

    /* the centre card changing, or cards being reordered, re-arms it */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { kick(); }).observe(track, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
    addEventListener('pageshow', kick);

    /* a short belt-and-braces poll for the first few seconds, in case the
       video element is replaced before any of the above has fired */
    var n = 0;
    var iv = setInterval(function () {
      if (++n > 40) { clearInterval(iv); return; }   /* ~10s */
      var v = centreVideo();
      if (visible && v && v.paused) kick();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
